import React, { useState, useCallback } from 'react';
import ReferContext from './ReferContext';
import { referService } from '../../services/refer/referService';

export const ReferState = ({ children }) => {
  const [agentDetails, setAgentDetails] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);

  const fetchPublicProfile = useCallback(async (agentParam) => {
    if (!agentParam) {
      setError(true);
      setLoading(false);
      return null;
    }

    try {
      setLoading(true);
      setError(false);
      const response = await referService.getPublicProfile(agentParam);
      if (response && response.success) {
        setAgentDetails(response.data);
        return response.data;
      } else {
        setError(true);
        return null;
      }
    } catch (err) {
      console.error('Error fetching agent details:', err);
      setError(true);
      return null;
    } finally {
      setLoading(false);
    }
  }, []);

  const value = {
    agentDetails,
    setAgentDetails,
    loading,
    error,
    fetchPublicProfile
  };

  return (
    <ReferContext.Provider value={value}>
      {children}
    </ReferContext.Provider>
  );
};

export default ReferState;
